import apiClient from './apiClient';

export interface QueryParams {
  productFrom?: string;
  productTo?: string;
  category?: number;
}

export interface ProductRow {
  code_front: string;
  code_back: string;
  full_code: string;
  category: number;
  spec: string;
}

export interface QueryResponse {
  data: ProductRow[];
  count: number;
  message?: string;
}

export const pw1313Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw1313/query', params);
    return res.data;
  },
};
